// extracted by mini-css-extract-plugin
module.exports = {"headCell":"PackagingMarginTable_headCell__2tdNG","subHeadCell":"PackagingMarginTable_subHeadCell__2-Wl6"};